import React from 'react'
import { Link } from 'react-router-dom'
import { PlaySquareOutlined } from '@ant-design/icons'
import { Button } from 'antd'

export function TrainerSettingsButton({ query, spotId, hero }) {
	return (
		<Link
			onClick={(e) => e.stopPropagation()}
			to={`/trainer?spot_id=${spotId}&q=${query}&hero=${hero}`}
			target='_blank'
			rel='noreferrer'
		>
			<PlaySquareOutlined
				style={{
					fontSize: 18,
					marginLeft: 5,
					height: 18,
					width: 18,
					'&:hover': { cursor: 'pointer' },
				}}
			/>
		</Link>
	)
}

export function HandsTrainLink({ query, spotId, train, hero }) {
	return (
		<Link to={`/trainer?spot_id=${spotId}&q=${query}&hero=${hero}`} rel='noreferrer' target='_blank'>
			<Button shape='round' size='small' type='link'>
				{train}
			</Button>
		</Link>
	)
}
